import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import areaSelect from '@/components/cascader.vue';
import country from '@/components/country.vue';
import tableControl from './tableControl.vue';
export default {
  props: {
    item2: {
      type: Object,
      default() {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    areaSelect,
    country,
    tableControl
  },
  data() {
    return {
      previewListVisible: false,
      modalPreviewList: [],
      tableIndex: 0,
      propsTree: {
        children: 'children',
        label: 'name',
        value: 'id',
        multiple: false
      }
    };
  },
  created() {
    let index = new Date().getTime();
    this.tableIndex = String(index).slice(-4);
  },
  methods: {
    onModalPreview(arr) {
      this.modalPreviewList = arr.map((item, i) => {
        let name = item.substring(item.lastIndexOf('/') + 1, item.lastIndexOf('.'));
        let format = item.substring(item.lastIndexOf('.')).toLowerCase();
        let obj = {};
        obj.status = 'done';
        obj.uid = i + 1;
        obj.url = item;
        obj.format = format.slice(1);
        obj.name = name + format;
        return obj;
      });
      console.log(this.modalPreviewList);
      this.previewListVisible = true;
    }
  }
};